<template>
  <div>

    <Head title="Extra" />
    <h1 class="mb-8 text-3xl font-bold">Parts</h1>
    <div class="grid grid-cols-1 gap-5 mt-6 sm:grid-cols-2 lg:grid-cols-3 mb-6">
      <div class="justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div class="p-6 min-w-max">
          <h2 class="font-bold text-center text-2xl text-indigo-500">
            Leads by Loan Officer
          </h2>
        </div>
        <div>
          <canvas ref="barChart" />
        </div>
      </div>
      <div class="items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div class="p-6 min-w-max">
          <h2 class="font-bold text-center text-2xl text-indigo-500">
            Leads by Loan Officer
          </h2>
        </div>
        <div>
          <canvas ref="doughnut" />
        </div>
      </div>
      <div class="items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div class="p-6 min-w-max">
          <h2 class="font-bold text-center text-2xl text-indigo-500">
            Leads by Loan Officer
          </h2>
        </div>
        <div>
          <canvas ref="polarArea" />
        </div>
      </div>
      <div class="justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div class="p-6 min-w-max">
          <h2 class="font-bold text-center text-2xl text-indigo-500">
            Closed by Loan Officer
          </h2>
        </div>
        <div>
          <canvas ref="barChartClosed" />
        </div>
      </div>
    </div>






    <h1 class="mb-8 text-3xl font-bold">Recent Contacts</h1>
    <!-- component -->
    <div class="container">
      <div class="flex flex-col md:grid grid-cols-9 mx-auto p-2 text-blue-50">
        <!-- left -->
        <div class="flex flex-row-reverse md:contents">
          <div
            class="bg-white col-start-1 col-end-5 p-4 rounded-xl my-4 ml-auto transition-shadow border rounded-lg shadow-md hover:shadow-xl">
            <h3 class="font-bold text-lg mb-1 text-gray-400">Left</h3>
            <p class="leading-tight text-justify text-gray-800">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Modi, quaerat?
            </p>
          </div>
          <div class="col-start-5 col-end-6 md:mx-auto relative mr-10">
            <div class="h-full w-6 flex items-center justify-center">
              <div class="h-full w-1 bg-blue-800 pointer-events-none" />
            </div>
            <div class="w-12 h-12 absolute top-1/2 -mt-6 -ml-3 rounded-full bg-blue-900 shadow">
              <i class="fas fa-sms text-white text-s absolute top-1/2 -mt-2 ml-4" />
            </div>
          </div>
        </div>
        <!-- right -->
        <div class="flex md:contents">
          <div class="col-start-5 col-end-6 mr-10 md:mx-auto relative">
            <div class="h-full w-6 flex items-center justify-center">
              <div class="h-full w-1 bg-blue-800 pointer-events-none" />
            </div>
            <div class="w-12 h-12 absolute top-1/2 -mt-6 -ml-3 rounded-full bg-blue-300 shadow">
              <i class="fas fa-envelope text-white text-s absolute top-1/2 -mt-2 ml-4" />
            </div>
          </div>
          <div
            class="bg-white col-start-6 col-end-10 p-4 rounded-xl my-4 mr-auto transition-shadow border rounded-lg shadow-md hover:shadow-xl">
            <h3 class="font-bold text-lg mb-1 text-gray-400">Right</h3>
            <p class="leading-tight text-justify text-gray-800">
              Lorem ipsum, dolor sit amet consectetur adipisicing elit.
              Vitae, facilis.
            </p>
          </div>
        </div>
        <!-- left -->
        <div class="flex flex-row-reverse md:contents">
          <div
            class="bg-white col-start-1 col-end-5 p-4 rounded-xl my-4 ml-auto transition-shadow border rounded-lg shadow-md hover:shadow-xl">
            <h3 class="font-bold text-lg mb-1 text-gray-400">Left</h3>
            <p class="leading-tight text-justify text-gray-800">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Modi, quaerat?
            </p>
          </div>
          <div class="col-start-5 col-end-6 md:mx-auto relative mr-10">
            <div class="h-full w-6 flex items-center justify-center">
              <div class="h-full w-1 bg-blue-800 pointer-events-none" />
            </div>
            <div class="w-12 h-12 absolute top-1/2 -mt-6 -ml-3 rounded-full bg-blue-500 shadow">
              <i class="fas fa-headset text-white text-s absolute top-1/2 -mt-2 ml-4" />
            </div>
          </div>
        </div>
        <!-- left -->
        <div class="flex flex-row-reverse md:contents">
          <div
            class="bg-white col-start-1 col-end-5 p-4 rounded-xl my-4 ml-auto transition-shadow border rounded-lg shadow-md hover:shadow-xl">
            <h3 class="font-bold text-lg mb-1 text-gray-400">Left</h3>
            <p class="leading-tight text-justify text-gray-800">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Modi, quaerat?
            </p>
          </div>
          <div class="col-start-5 col-end-6 md:mx-auto relative mr-10">
            <div class="h-full w-6 flex items-center justify-center">
              <div class="h-full w-1 bg-blue-800 pointer-events-none" />
            </div>
            <div class="w-12 h-12 absolute top-1/2 -mt-6 -ml-3 rounded-full bg-blue-300 shadow">
              <i class="fas fa-envelope text-white text-s absolute top-1/2 -mt-2 ml-4" />
            </div>
          </div>
        </div>
        <!-- right -->
        <div class="flex md:contents">
          <div class="col-start-5 col-end-6 mr-10 md:mx-auto relative">
            <div class="h-full w-6 flex items-center justify-center">
              <div class="h-full w-1 bg-blue-800 pointer-events-none" />
            </div>
            <div class="w-12 h-12 absolute top-1/2 -mt-6 -ml-3 rounded-full bg-blue-800 shadow">
              <i class="fas fa-sms text-white text-s absolute top-1/2 -mt-2 ml-4" />
            </div>
          </div>
          <div
            class="bg-white col-start-6 col-end-10 p-4 rounded-xl my-4 mr-auto transition-shadow border rounded-lg shadow-md hover:shadow-xl">
            <h3 class="font-bold text-lg mb-1 text-gray-400">Right</h3>
            <p class="leading-tight text-justify text-gray-800">
              Lorem ipsum, dolor sit amet consectetur adipisicing elit.
              Vitae, facilis.
            </p>
          </div>
        </div>
      </div>
    </div>




  </div>
</template>

<script>
import { Head } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import Chart from 'chart.js/auto'

export default {
  components: {
    Head,
  },
  layout: Layout,
  props: {
    loLeadCountThisMonth: Object,
    loClosed: Object,
  },

  mounted() {
    const barChart = this.$refs.barChart
    const barChartClosed = this.$refs.barChartClosed
    const doughnut = this.$refs.doughnut
    const polarArea = this.$refs.polarArea

    const data = this.loLeadCountThisMonth
    const labelsThisMonth = data.map(item => item.name)
    console.log(labelsThisMonth)
    const valuesThisMonth = data.map(item => item.count)
    console.log(valuesThisMonth)
    const backgroundColor = [
      'rgba(75, 192, 192, 0.2)',
      'rgba(54, 162, 235, 0.2)',
      'rgba(153, 102, 255, 0.2)',
      'rgba(255, 99, 132, 0.2)',
      'rgba(255, 159, 64, 0.2)',
      'rgba(255, 205, 86, 0.2)',
      'rgba(201, 203, 207, 0.2)',
      'rgba(128, 0, 128, 0.2)', // Purple
      'rgba(0, 128, 0, 0.2)',   // Green
      'rgba(255, 0, 0, 0.2)',   // Red
      'rgba(0, 255, 255, 0.2)', // Cyan
      'rgba(255, 165, 0, 0.2)', // Orange
      'rgba(128, 128, 0, 0.2)', // Olive
      'rgba(255, 192, 203, 0.2)', // Pink
      'rgba(0, 0, 128, 0.2)', // Navy
      'rgba(128, 0, 0, 0.2)', // Maroon
      'rgba(0, 128, 128, 0.2)', // Teal
    ];

    const borderColor = [
      'rgba(75, 192, 192, 0.2)',
      'rgb(54, 162, 235)',
      'rgb(153, 102, 255)',
      'rgb(201, 203, 207)',
      'rgb(255, 99, 132)',
      'rgb(255, 159, 64)',
      'rgb(255, 205, 86)',
      'rgb(75, 192, 192)',
      'rgb(128, 0, 128)', // Purple
      'rgb(0, 128, 0)',   // Green
      'rgb(255, 0, 0)',   // Red
      'rgb(0, 255, 255)', // Cyan
      'rgb(255, 165, 0)', // Orange
      'rgb(128, 128, 0)', // Olive
      'rgb(255, 192, 203)', // Pink
      'rgb(0, 0, 128)', // Navy
      'rgb(128, 0, 0)', // Maroon
      'rgb(0, 128, 128)', // Teal
    ];

    new Chart(barChart, {
      type: 'bar',
      data: {
        labels: labelsThisMonth,
        datasets: [{
          label: 'Lead Count by Loan Officer',
          data: valuesThisMonth,
          backgroundColor: backgroundColor,
          borderColor: borderColor,
          borderWidth: 1,
        }],
      },
      options: {
        scales: {
          y: {
            beginAtZero: true,
          }
        },
      }
    });


    const dataClosed = this.loClosed
    const labelsClosed = dataClosed.map(item => item.name)
    const valuesClosed = dataClosed.map(item => item.count)


    new Chart(barChartClosed, {
      type: 'bar',
      data: {
        labels: labelsClosed,
        datasets: [{
          label: 'Closed by Loan Officer',
          data: valuesClosed,
          backgroundColor: backgroundColor,
          borderColor: borderColor,
          borderWidth: 1,
        }],
      },
      options: {
        scales: {
          y: {
            beginAtZero: true,
          }
        },
      }
    });


    new Chart(doughnut, {
      type: 'doughnut',
      data: {
        labels: labelsThisMonth,
        datasets: [{
          label: 'Loan Officer Leads',
          data: valuesThisMonth,
          backgroundColor: backgroundColor,
          borderColor: borderColor,
          borderWidth: 1,
          hoverOffset: 4,
        }],
      },
    });




    new Chart(polarArea, {
      type: 'polarArea',
      data: {
        labels: labelsThisMonth,
        datasets: [{
          label: 'Loan Officer Leads',
          data: valuesThisMonth,
          backgroundColor: backgroundColor,
          borderColor: borderColor,
          borderWidth: 1,
          hoverOffset: 4,
        }],
      },
    })
    //end mounted
  },

}
</script>
